import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FormTextarea,
  title: 'TextArea',
  category: ComponentCategory.FormControls,
};
